import { useState } from 'react';
import Neuron from './Neuron/Neuron';
import { useEventListener } from 'ahooks';
import styled from '@emotion/styled';
import Header from './Header';

function GroupSetting() {
  const [height, setHeight] = useState('auto');

  useEventListener('message', (e) => {
    if (e.data && e.data.type === 'contentHeight') {
      setHeight(e.data.data);
    }
  });

  return (
    <Container>
      <Header />
      <div>
        <Neuron path="qa/setting" style={{ height, marginBottom: '16px' }} />
      </div>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
  > header {
    flex: 0 0 auto;
    margin-bottom: 16px;
  }
  > div {
    flex: 1 0 0;
    overflow: auto;
  }
`;

export default GroupSetting;
